const updatePriority = (priority) => {
  if (typeof window !== 'undefined' && window.mapiUtils.updateRequestPriority) {
    try {
      window.mapiUtils.updateRequestPriority(priority)
    } catch (error) {
      /* eslint no-console:off */
      console.error('Error updating request priority:', error)
    }
  }
}

export default updatePriority
